<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Workshop</h4>
    <hr >
    <b-row class="mb-3">
      <b-col>
        <b-btn
          variant="success"
          size="sm"
          @click="openModal()">
          <i class="fa fa-plus" />&nbsp;
          Add
        </b-btn>
      </b-col>
    </b-row>
    <b-table
      v-if="items.length && !isFetching"
      :fields="fields"
      :items="items"
      :per-page="10"
      :current-page="currentPage"
      hover
      responsive
      striped>
      <template #head(action)>
        <div :style="{'width': '85px'}">Action</div>
      </template>
      <template v-slot:cell(action)="row" style="width: 150px">
        <b-btn
          v-b-tooltip.hover
          size="sm"
          variant="warning"
          title="Edit"
          @click="openModal(row.item)">
          <i class="fa fa-pencil" />
        </b-btn>
        <b-btn
          v-b-tooltip.hover
          size="sm"
          variant="danger"
          title="Delete"
          class="ml-2"
          @click="removeItem(row.item)">
          <i class="fa fa-close" />
        </b-btn>
      </template>
    </b-table>
    <b-pagination
      v-show="items.length > 10 && !isFetching"
      :total-rows="items.length"
      :per-page="10"
      v-model="currentPage" />

    <b-modal
      id="upsert-modal"
      :scrollable="true"
      :title="`${modalAction} Workshop`"
      header-bg-variant="success"
      hide-footer
      size="md"
      @hidden="selectedItem = {}">
      <b-form @submit.stop.prevent="upsertItem">
        <b-row>
          <b-col sm="6">
            <b-form-group label="Vendor">
              <b-form-input
                v-model="selectedItem.vendor"
                :state="validateState('vendor')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Service Provided">
              <b-form-input
                v-model="selectedItem.serviceProvided"
                :state="validateState('serviceProvided')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Address">
              <b-form-input
                v-model="selectedItem.address"
                :state="validateState('address')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Roc Number">
              <b-form-input
                v-model="selectedItem.rocNumber"
                :state="validateState('rocNumber')"
                size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Bank">
              <b-form-input
                v-model="selectedItem.bank"
                :state="validateState('bank')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Account Number">
              <b-form-input
                v-model="selectedItem.accountNumber"
                :state="validateState('accountNumber')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Card Number">
              <b-form-input
                v-model="selectedItem.cardNumber"
                :state="validateState('cardNumber')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="PIC">
              <b-form-input
                v-model="selectedItem.pic"
                :state="validateState('pic')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Mobile Number">
              <b-form-input
                v-model="selectedItem.mobileNumber"
                :state="validateState('mobileNumber')"
                size="sm" />
              <b-form-invalid-feedback>
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <div class="text-right">
          <b-btn
            :disabled="isSubmitting"
            variant="primary"
            type="submit">{{ modalAction }}</b-btn>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex'
import { toastr } from '@/services'

export default {
  name: 'Workshop',
  mixins: [validationMixin],
  data () {
    return {
      modalAction: 'Add',
      selectedItem: {},
      isFetching: false,
      currentPage: 1,
      isSubmitting: false
    }
  },
  validations: {
    selectedItem: {
      vendor: {
        required
      },
      address: {
        required
      },
      rocNumber: {
        required
      },
      serviceProvided: {
        required
      },
      bank: {
        required
      },
      accountNumber: {
        required
      },
      cardNumber: {
        required
      },
      mobileNumber: {
        required
      },
      pic: {
        required
      },
    }
  },
  computed: {
    ...mapState('workshop', [
      'items',
      'fields'
    ])
  },
  created () {
    this.fetchWorkshops()
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.selectedItem[name];
      return $dirty ? !$error : null;
    },
    async fetchWorkshops () {
      try {
        this.isFetching = true
        await this.$store.dispatch('workshop/fetchWorkshops')
        this.isFetching = false
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    },
    openModal (item) {
      if (item) {
        this.selectedItem = {...item}
        this.modalAction = 'Edit'
      } else {
        this.modalAction = 'Add'
      }
      this.$bvModal.show('upsert-modal')
    },
    async upsertItem () {
      try {
        this.$v.selectedItem.$touch()
        if (this.$v.selectedItem.$invalid) {
          return
        }
        this.isSubmitting = true
        await this.$store.dispatch('workshop/upsertWorkshop', this.selectedItem)
        this.isSubmitting = false
        this.$bvModal.hide('upsert-modal')
        this.selectedItem = {}
        this.$v.selectedItem.$reset()
        toastr.success(false, 2000)
        this.fetchWorkshops()
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    },
    async removeItem (item) {
      try {
        await this.$store.dispatch('workshop/deleteWorkshop', item.rocNumber)
        toastr.info('Item successfully removed', false, 2000)
        this.fetchWorkshops()
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    }
  }
}
</script>